<template>
  <main>
    <div class="header__wrapper">
      <!-- Back button - Title - Last time saved -->
      <header class="header__details">
        <a-button type="link" class="back-button" @click="handleBack">
          <ArrowLeftOutlined />
          Volver
        </a-button>

        <div class="title">
          <h2 class="name">{{ templateDetails?.name || "Cargando..." }}</h2>

          <!--Estado de chatbot-->
          <!-- <a-tag v-if="templateDetails.status" :color="StatusProps[templateDetails.status].color">
            {{ StatusProps[templateDetails.status].text }}
          </a-tag> -->
        </div>

        <div class="save-time">
          Guardado por ultima vez:
          {{ dayjs(templateDetails?.updated_at).format("DD/MM/YYYY") || "..." }}
        </div>
      </header>
    </div>

    <!-- Tabs - Status switch -->
    <a-tabs v-model:activeKey="currentTab" centered destroyInactiveTabPane>
      <template #leftExtra>
        <a-tooltip
          title="Esta plantilla se encuentra utilizando una variable que ha sido eliminada. Podrás volver a activar tu plantilla cuando esta variable sea reemplazada."
          placement="right"
          arrowPointAtCenter
        >
          <a-tag v-if="templateDetails?.deleted_variable" color="warning">
            <WarningFilled />
            Variable eliminada
          </a-tag>
        </a-tooltip>
      </template>

      <template #rightExtra>
        <div class="extra-action">
          <a-button type="link" class="button" @click="openTestModal = true">
            <SendOutlined :rotate="-45" />
            Enviar correo de prueba
          </a-button>

          <a-divider type="vertical" class="divider" />

          <DisableSwitch
            inTemplate
            v-if="templateDetails"
            :template="templateDetails"
            @update="fetchTemplate"
          />
        </div>
      </template>

      <a-tab-pane :key="TemplateTabsKey.Build" :tab="TabSectionName[TemplateTabsKey.Build]">
        <EditTemplateSection
          v-if="templateDetails"
          :template="templateDetails"
          :items="templateDetails.items || []"
          @updateTemplate="updateTemplate"
        />
      </a-tab-pane>

      <a-tab-pane :key="TemplateTabsKey.General" :tab="TabSectionName[TemplateTabsKey.General]">
        <div class="container-tab">
          <h3>Datos generales</h3>

          <TemplateDataForm
            v-if="templateDetails"
            :templateType="templateDetails?.template_type"
            :template="templateDetails"
          />
        </div>
      </a-tab-pane>

      <a-tab-pane
        v-if="templateDetails?.template_type !== TemplateType.Html"
        :key="TemplateTabsKey.Variables"
        :tab="TabSectionName[TemplateTabsKey.Variables]"
      >
        <div class="container-tab">
          <h3>Parámetros</h3>
          <VariablesTemplate :template="templateDetails" @update="fetchTemplate" />
        </div>
      </a-tab-pane>
    </a-tabs>

    <!-- <footer v-if="current !== TemplateTabsKey.BuildBot">
      <a-button @click="handleCancel" :disabled="isBotActive"> Cancelar </a-button>
      <a-button
        type="primary"
        @click="handleUpdateBot"
        :disabled="isUpdateButtonDisabled || isBotActive"
        :loading="loading"
      >
        Actualizar {{ TabSectionName[current] }}
      </a-button>
    </footer> -->
  </main>

  <SendTestMailModal
    v-if="openTestModal"
    v-model:open="openTestModal"
    :template="templateDetails"
  />
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ArrowLeftOutlined, SendOutlined, WarningFilled } from "@ant-design/icons-vue";
import dayjs from "dayjs";

import { TemplateTabsKey } from "@/@types/flows/emailTemplates/components";
import { Template, TemplateType } from "@/@types/flows/emailTemplates";
import { emailTemplateService } from "@/app/flows/emailTemplates/services/EmailTemplate.service";
import { TemplateItemsManager } from "@/app/flows/emailTemplates/utils/TemplateItemsManager";

import DisableSwitch from "@/app/flows/emailTemplates/components/buttons/DisableSwitch.vue";
import VariablesTemplate from "@/app/flows/emailTemplates/templates/VariablesTemplate.vue";
import EditTemplateSection from "@/app/flows/emailTemplates/components/sections/EditTemplateSection.vue";
import TemplateDataForm from "@/app/flows/emailTemplates/components/forms/TemplateDataForm.vue";
import SendTestMailModal from "@/app/flows/emailTemplates/components/modals/SendTestMailModal.vue";

const TabSectionName = {
  [TemplateTabsKey.Build]: "Construir plantilla",
  [TemplateTabsKey.General]: "Datos generales",
  [TemplateTabsKey.Variables]: "Parámetros",
};

const TabParamName = {
  [TemplateTabsKey.Build]: "construct",
  [TemplateTabsKey.General]: "general",
  [TemplateTabsKey.Variables]: "params",
};

const router = useRouter();
const route = useRoute();

const templateDetails = ref<Template>();

const handleBack = () => router.push("/email/templates-email");

const openTestModal = ref(false);

const fetchTemplate = async () => {
  const templateId = Number(route.params.id);

  templateDetails.value = await emailTemplateService.getTemplateById(templateId);
  TemplateItemsManager.initializeTemplateItems(templateDetails.value.items);
};

const updateTemplate = async (templateDetailsAux: any) => {
  templateDetails.value = Object.assign(templateDetailsAux);
};

function getKeyByValue(obj: any, value: any) {
  return Object.entries(obj).find(([key, val]) => val === value)?.[0] || null;
}

const currentTab = ref(TemplateTabsKey.Build);

watch(currentTab,
  (value: any) => {
    router.push({ query: { tab: TabParamName[value] }});
    if (value == TemplateTabsKey.General) {
      fetchTemplate();
    }
    // if (value == TemplateTabsKey.Variables) {
    //   router.push({ query: { tab: 'params' } });
    // } else if (value == TemplateTabsKey.General) {
    //   router.push({ query: { tab: 'general' } });
    // } else {
    //   router.push({ query: { tab: 'construct' } });
    // }
    // console.log(value, 'current tab');
  }
);

onMounted(async () => {
  try {
    TemplateItemsManager.initializeTemplateItems([]);
    await fetchTemplate();
    setTimeout(() => {
      const key = getKeyByValue(TabParamName, route.query.tab);
      console.log(key, 'get key by value');
      if (key) currentTab.value = key;
    }, 0);
  } catch (error) {
    console.log(error, 'error on mounted');
  }
});
</script>

<style scoped lang="sass">
.button
  padding: 0

.divider
  background-color: #00000026
  height: 1.2em

h3
  font-size: 16px
  font-weight: 600
  color: $gray-9
  margin-bottom: 16px
  padding-bottom: 8px
  border-bottom: 1px solid $gray-5

main
  background-color: $geekblue-1
  height: 100%

.header
  &__wrapper
    width: 100%
    padding: 6px 12px 0
    background-color: $white

  &__details
    display: flex
    justify-content: center
    align-items: center
    position: relative
    width: 100%

    .back-button
      padding: 0
      position: absolute
      left: 0

    .title
      display: flex
      align-items: center
      gap: 8px

      .name
        font-size: 16px
        font-weight: 600
        color: $gray-9
        margin: 0

    .save-time
      font-style: italic
      font-weight: 300
      font-size: 12px
      position: absolute
      right: 0

.extra-action
  display: flex
  align-items: center

:deep(.ant-tabs-nav)
  background-color: white
  // margin-bottom: 12px !important
  margin-bottom: 0 !important

:deep(.ant-tabs)
  height: 100%

:deep(.ant-tabs-content)
  height: 100%

:deep(.ant-tabs-nav .ant-tabs-extra-content:nth-child(1))
  position: absolute
  left: 12px

:deep(.ant-tabs-nav .ant-tabs-extra-content:nth-child(3))
  position: absolute
  right: 12px

:deep(.ant-tabs-tabpane)
  height: 100%

:deep(.ant-tabs-tabpane:not(:first-child))
  background-color: white

.ant-spin-nested-loading
  height: calc(100% - 30px)

:deep(.ant-spin-container)
  height: 100%

.container-tab
  margin: 1rem auto 0
  max-width: 50%
  height: calc(100% - 1rem)

footer
  margin: 0 auto
</style>
